import { dpr } from 'Utils/dpr';
import tailwindBreakpoints from 'Utils/tailwindBreakpoints';

import { IBannerBlockItemViewModel } from 'Types/Litium';
import Markup from 'Components/Markup';

interface BannerBlockItemViewModel extends IBannerBlockItemViewModel {
    shouldLazyLoad?: boolean;
    srcSetSizes: {
        default: number;
        md: number;
        lg: number;
        xl: number;
        xxl: number;
        xxxl: number;
    };
}

const BannerSliderItem = ({
    linkUrl,
    linkText,
    image,
    imageMobile,
    sliderBlockText,
    sliderBlockTextPosition,
    sliderBlockTextMaxPercentage,
    srcSetSizes,
    shouldLazyLoad = false,
}: BannerBlockItemViewModel) => {
    const Wrapper = linkUrl ? 'a' : 'div';

    return (
        <div className="flex flex-col">
            <Wrapper {...(linkUrl && { href: linkUrl, title: linkText })}>
                <figure className="relative flex items-center justify-center">
                    {linkText && (
                        <h2 className="absolute text-center font-montserrat text-2xl font-semibold text-starkWhite lg:text-xl">
                            {linkText}
                        </h2>
                    )}
                    <picture className="h-full w-full object-cover">
                        <source
                            width={image.width > 0 ? image.width : ''}
                            height={image.height > 0 ? image.height : ''}
                            media={`(min-width: ${tailwindBreakpoints.xxxl})`}
                            srcSet={dpr(
                                `${image.src}?format=webp&width=${srcSetSizes.xxxl}`
                            )}
                        />
                        <source
                            width={image.width > 0 ? image.width : ''}
                            height={image.height > 0 ? image.height : ''}
                            media={`(min-width: ${tailwindBreakpoints.xxl})`}
                            srcSet={dpr(
                                `${image.src}?format=webp&width=${srcSetSizes.xxl}`
                            )}
                        />
                        <source
                            width={image.width > 0 ? image.width : ''}
                            height={image.height > 0 ? image.height : ''}
                            media={`(min-width: ${tailwindBreakpoints.xl})`}
                            srcSet={dpr(
                                `${image.src}?format=webp&width=${srcSetSizes.xl}`
                            )}
                        />
                        <source
                            width={image.width > 0 ? image.width : ''}
                            height={image.height > 0 ? image.height : ''}
                            media={`(min-width: ${tailwindBreakpoints.lg})`}
                            srcSet={dpr(
                                `${image.src}?format=webp&width=${srcSetSizes.lg}`
                            )}
                        />
                        <source
                            width={
                                imageMobile?.src
                                    ? imageMobile?.width > 0
                                        ? imageMobile?.width
                                        : ''
                                    : image?.width > 0
                                      ? image?.width
                                      : ''
                            }
                            height={
                                imageMobile?.src
                                    ? imageMobile?.height > 0
                                        ? imageMobile?.height
                                        : ''
                                    : image?.height > 0
                                      ? image?.height
                                      : ''
                            }
                            media={`(min-width: ${tailwindBreakpoints.md})`}
                            srcSet={
                                imageMobile?.src
                                    ? dpr(
                                          `${imageMobile?.src}?format=webp&width=${srcSetSizes.md}`
                                      )
                                    : dpr(
                                          `${image?.src}?format=webp&width=${srcSetSizes.md}`
                                      )
                            }
                        />
                        <img
                            width={
                                imageMobile?.src
                                    ? imageMobile?.width > 0
                                        ? imageMobile?.width
                                        : ''
                                    : image?.width > 0
                                      ? image?.width
                                      : ''
                            }
                            height={
                                imageMobile?.src
                                    ? imageMobile?.height > 0
                                        ? imageMobile?.height
                                        : ''
                                    : image?.height > 0
                                      ? image?.height
                                      : ''
                            }
                            className="h-full w-full object-cover"
                            src={
                                imageMobile?.src
                                    ? `${imageMobile?.src}?format=webp&width=${srcSetSizes.default}`
                                    : `${image?.src}?format=webp&width=${srcSetSizes.default}`
                            }
                            srcSet={
                                imageMobile?.src
                                    ? dpr(
                                          `${imageMobile?.src}?format=webp&width=${srcSetSizes.default}`
                                      )
                                    : dpr(
                                          `${image?.src}?format=webp&width=${srcSetSizes.default}`
                                      )
                            }
                            alt={imageMobile?.altText}
                            loading={shouldLazyLoad ? 'lazy' : 'eager'}
                        />
                    </picture>
                </figure>
            </Wrapper>
            {sliderBlockText?.value && (
                <Markup
                    html={sliderBlockText?.value}
                    cssClass={`prose-block mx-auto my-0 w-full lg:w-[var(--text-width)]
                ${
                    sliderBlockTextPosition === 'top'
                        ? 'order-first'
                        : 'order-last'
                } ${
                    sliderBlockTextPosition === 'top'
                        ? 'mb-3 mt-0'
                        : 'mt-3 mb-0'
                }`}
                    style={
                        {
                            '--text-width': `${sliderBlockTextMaxPercentage}%`,
                        } as React.CSSProperties
                    }
                />
            )}
        </div>
    );
};

export default BannerSliderItem;
